// @ts-check
import { ReactQueryDevtools } from "react-query/devtools";

/**
 * Development-only React Query Devtools wrapper
 * @returns {import("react").ReactElement | null}
 */
export function QueryDevtools() {
  if (process.env.NODE_ENV !== "development") {
    return null;
  }

  return (
    <ReactQueryDevtools
      initialIsOpen={false}
      position="bottom-right"
      toggleButtonProps={{
        style: {
          backgroundColor: "#269EB9",
          color: "white",
          fontSize: "12px",
          padding: "8px 12px",
          borderRadius: "4px",
          border: "none",
          cursor: "pointer",
          zIndex: 9999,
        },
      }}
    />
  );
}

export const devHelpers = {
  /**
   * Log all queries in the cache
   * @param {import("react-query").QueryClient} queryClient
   */
  logQueries: (queryClient) => {
    if (process.env.NODE_ENV === "development") {
      const queries = queryClient.getQueryCache().getAll();
      console.group("🔍 React Query Cache");
      queries.forEach((query) => {
        console.log(`Query Key: ${JSON.stringify(query.queryKey)}`);
        console.log(`Status: ${query.state.status}`);
        console.log(`Data: `, query.state.data);
        console.log("---");
      });
      console.groupEnd();
    }
  },

  /**
   * Log all mutations
   * @param {import("react-query").QueryClient} queryClient
   */
  logMutations: (queryClient) => {
    if (process.env.NODE_ENV === "development") {
      const mutations = queryClient.getMutationCache().getAll();
      console.group("🔄 React Query Mutations");
      mutations.forEach((mutation) => {
        console.log(`Mutation ID: ${mutation.mutationId}`);
        console.log(`Status: ${mutation.state.status}`);
        console.log(`Variables: `, mutation.state.variables);
        console.log("---");
      });
      console.groupEnd();
    }
  },

  /**
   * Clear all queries and mutations
   * @param {import("react-query").QueryClient} queryClient
   */
  clearCache: (queryClient) => {
    if (process.env.NODE_ENV === "development") {
      queryClient.clear();
      console.log("🗑️ React Query cache cleared");
    }
  },
};

if (process.env.NODE_ENV === "development") {
  window.__RQ_DEV_HELPERS__ = devHelpers;
}
